module.exports = __webpack_public_path__ + "img/acctopus-logo.37c63265.svg";